import { render } from "./ContactBooksSchemaEditorItemProperties.vue?vue&type=template&id=3fe07bd2&scoped=true&ts=true"
import script from "./ContactBooksSchemaEditorItemProperties.vue?vue&type=script&lang=ts"
export * from "./ContactBooksSchemaEditorItemProperties.vue?vue&type=script&lang=ts"

import "./ContactBooksSchemaEditorItemProperties.vue?vue&type=style&index=0&id=3fe07bd2&lang=scss&scoped=true"

import exportComponent from "/Users/andreynikitenko/Developer/contacts-mono/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.4.31_vue@3.4.31_typescript@5.5.3__webpack@5.92.1_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe07bd2"]])

export default __exports__